import React from 'react';
import PropTypes from 'prop-types';
import Reviews from '@fiverr-private/reviews/src/reviews';
import SafePureComponent from '../shared/SafePureComponent';
import { validateReviews } from '../../utils/mainComponentsValidator';
import { PAGE_NAME } from '../../utils/events';
import { DEFAULT_REVIEWS_SORT } from '../../utils/constants/reviews';

import './style.scss';

const GIG_PAGE = 'gig_page';

const GigReviews = ({ reviews = {} }, { requestContext, general, rollouts = {} }) => {
    if (!validateReviews({ reviews })) {
        return null;
    }

    const {
        page_ctx_id: pageCtxId,
        is_mobile: isMobile,
        current_user: currentUser
    } = requestContext;

    const {
        isPro
    } = general;

    const enrichData = {
        pathFinderConfig: {
            path: 'fetch_reviews',
            params: {
                perseus_name: GIG_PAGE,
                gig_id: reviews.gig_id
            }
        },
        pageCtxId,
        pageName: PAGE_NAME,
        type: DEFAULT_REVIEWS_SORT,
        displayRelevant: true,
        biEventGroup: GIG_PAGE,
        displayBreakdown: !isMobile,
        displayHelpful: rollouts.reviewsHelpful,
        currentUserId: currentUser ? currentUser.id : null
    };

    return (
        <Reviews initialState={({ ...reviews, ...enrichData })} isPro={isPro} className="gig-reviews"/>
    );
};

GigReviews.propTypes = {
    reviews: PropTypes.object
};

GigReviews.contextTypes = {
    requestContext: PropTypes.object,
    rollouts: PropTypes.object,
    general: PropTypes.object
};

export { GigReviews };
export default SafePureComponent(GigReviews);
